import { twMerge } from "tailwind-merge";
import type { IconProps } from "./types";

export const Heading2 = ({ size, color, className, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={twMerge(color == null && "h-5 w-5 stroke-current", className)}
    stroke={color}
    fill="none"
    {...props}
  >
    <path
      d="M3.5 5V19M12.5 5V19M5 5H2M12.5 12L3.5 12M5 19H2M14 19H11M14 5H11"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3047 11.4318V9.97582C17.6767 9.73315 19.0954 9.61182 20.5607 9.61182C21.5967 9.61182 22.3667 9.92448 22.8707 10.5498C23.356 11.1472 23.5987 11.8938 23.5987 12.7898C23.5987 14.3485 22.3107 16.1498 19.7347 18.1938H23.5987V19.9998H16.4167V18.2778C17.1634 17.7738 17.8727 17.2325 18.5447 16.6538C19.226 16.0751 19.7674 15.5805 20.1687 15.1698C20.5794 14.7591 20.9247 14.3345 21.2047 13.8958C21.4847 13.4665 21.6247 13.0978 21.6247 12.7898C21.6247 12.4818 21.5687 12.2251 21.4567 12.0198C21.2327 11.6278 20.7287 11.4318 19.9447 11.4318H16.3047Z"
      stroke="none"
      className="fill-current"
    />
  </svg>
);
